import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import SendIcon from '@mui/icons-material/Send';

interface SendButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export const SendButton: React.FC<SendButtonProps> = ({ loading, disabled = false, onClick }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<SendIcon />}
            onClick={onClick}
        >
            <Localized id="send">_Send</Localized>
        </LoadingButton>
    );
};
